import { z } from 'zod';

import { zodDeliveryNotesAdminQueryParametersSchema } from '~/data/delivery';

import { DELIVERY_NOTE_SIDEBAR_CONTENT } from '~/modules/delivery-notes/view/constants';

import { FILTER_DATE_RANGES } from '~/utils';

export const zodDeliveryNotesSearchParamsSchema =
  zodDeliveryNotesAdminQueryParametersSchema
    .omit({
      limit: true,
      offset: true,
    })
    .extend({
      canAddGroups: z.coerce.boolean().optional().prefault(false),
      dateRangeLabel: z
        .enum(Object.keys(FILTER_DATE_RANGES))
        .prefault('last30Days')
        .catch('last30Days'),
      page: z.coerce
        .number()
        .int()
        .nonnegative()
        .optional()
        .prefault(0)
        .catch(0),
      showFilters: z.coerce.boolean().optional().prefault(false),
      withAggregators: z.coerce.boolean().optional().prefault(false),
    });

export const zodDeliveryNoteSearchParamsSchema = z
  .object({
    searchStringLineItems: z.string().trim().optional().prefault(''),
    showJsonData: z.boolean().optional().prefault(false),
    showLineItemDetails: z.string().trim().optional(),
    showSidebar: z
      .enum(DELIVERY_NOTE_SIDEBAR_CONTENT)
      .optional()
      .catch(undefined),
    viewAttachment: z.string().trim().optional(),
  })
  .transform((data) => {
    return {
      ...data,
      ...(data.viewAttachment ? { showSidebar: 'attachments' } : {}),
    };
  });
